module.exports = __webpack_public_path__ + "img/BINDI 4 GREEN.c00dd51.svg";